import React from 'react';
import PropTypes from 'prop-types';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';

function CustomTimePicker({ value, setFieldValue, name, label }) {
  return (
    <TextField
      // Forward the field name to the input's id/name so form-level
      // scroll-to-error targeting (getElementById / [name=...]) can locate it.
      id={name}
      name={name}
      value={value}
      label={label}
      type="time"
      variant="standard"
      onChange={(e) => setFieldValue(name, e.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        step: 300,
        name,
      }}
      sx={{ width: '100%' }}
    />
  );
}

CustomTimePicker.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default CustomTimePicker;
